import React from "react";
import { Box, Paper, Typography, Button } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { useNavigate } from "react-router-dom";

const FormSubmittedUi = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: "#f9f9f9",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: 2,
      }}
    >
      <Paper
        elevation={4}
        sx={{
          maxWidth: { xs: "90%", sm: 600, md: 800 },
          height: { xs: "auto", md: "40vh" }, 
          width: "100%",
          border: "2px solid #A91674",
          borderRadius: "12px",
          p: { xs: 2, sm: 4 }, 
          textAlign: "center",
        }}
      >
        <CheckCircleOutlineIcon
          sx={{
            fontSize: { xs: 60, sm: 80 },
            color: "#A91674",
          }}
        />
        <Typography
          variant="h4" 
          sx={{
            mt: 2,
            mb: 1,
            fontWeight: 600,
            fontSize: { xs: "1.5rem", sm: "2rem" }, 
          }}
        >
          Form Submitted!
        </Typography>

        <Typography
          sx={{
            color: "#555",
            fontStyle: "italic",
            mt: 2,
            fontSize: { xs: 14, sm: 18 }, 
          }}
        >
          Your data has been securely received and recorded for research use only.
        </Typography>
      </Paper>
    </Box>
  );
};

export default FormSubmittedUi;